import React, { useState, useEffect, useRef, useCallback } from "react";
import logo from "../assets/logo_nobg.png";
import { collection, addDoc, serverTimestamp, getCountFromServer } from "firebase/firestore";
import { db } from "../firebase";

// ── Existing data kept ────────────────────────────────────────────────────────
const SITES = [
  { id: "cleaning", name: "SparkleClean Pro",  niche: "Cleaning Service", url: "https://cleaning.shashankupadhyaya.com", bg: ["#0e2a33","#0a1418"], bar: "#2dd4bf" },
  { id: "roofing",  name: "Apex Roofing",      niche: "Roofing Company",  url: "https://roofing.shashankupadhyaya.com",  bg: ["#1a1010","#0f0a0a"], bar: "#dc2626" },
  { id: "hvac",     name: "ArcticBreeze HVAC", niche: "HVAC Company",     url: "https://hvac.shashankupadhyaya.com",     bg: ["#eef4ff","#dbe7fb"], bar: "#3b82f6", light: true },
  { id: "plumbing",     name: "FlowMaster Plumbing",  niche: "Plumbing Company",  url: "https://plumbing.shashankupadhyaya.com",     bg: ["#0a1a2a","#061018"], bar: "#0d9488" },
  { id: "electrician", name: "BrightSpark Electric", niche: "Electrician",       url: "https://electrician.shashankupadhyaya.com", bg: ["#1a1400","#0d0900"], bar: "#fbbf24" },
  { id: "landscaping", name: "GreenEdge Landscaping",niche: "Landscaping",       url: "https://landscaping.shashankupadhyaya.com", bg: ["#0a1a0a","#060d06"], bar: "#4ade80" },
  { id: "painting",     name: "BrushMaster Painting",   niche: "Painting Service",    url: "https://painting.shashankupadhyaya.com",        bg: ["#150a1a","#0a060f"], bar: "#c084fc" },
  { id: "pest-control", name: "ShieldGuard Pest Control", niche: "Pest Control",        url: "https://pest-control.shashankupadhyaya.com",    bg: ["#0f1a0a","#080e05"], bar: "#84cc16", no3d: true },
  { id: "moving",       name: "SwiftMove Co.",            niche: "Moving Company",      url: "https://moving.shashankupadhyaya.com",          bg: ["#1a0e00","#0d0700"], bar: "#f97316", no3d: true },
];

const FAQ_DATA = [
  { q: "How much does a website cost?", a: "Most local-business sites are a one-time build fee plus an optional low monthly care plan for hosting, updates and support. You get an exact, fixed quote after your free mockup - no surprises and no hourly billing." },
  { q: "How long until my site is live?", a: "Typically 1 week from approval. We move fast because we start from a working mockup, so you are reviewing a real design in days, not waiting months." },
  { q: "Do I own my website?", a: "100%. The domain, the site and the content are all yours. No lock-in - if you ever leave, you take everything with you." },
  { q: "What if I already have a website?", a: "Even better. We redesign it to load faster, look modern and actually convert visitors into calls and bookings, then migrate everything cleanly." },
  { q: "Will it show up on Google?", a: "Yes. Every build includes local SEO fundamentals: optimised headings, meta tags, schema markup and fast load times, so the right customers in your area can find you." },
];

const SERVICES = [
  { title: "Conversion-first design", desc: "Every page is built around one thing: getting visitors to call, book or fill out your form.", svg: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C7F94B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4"/><circle cx="12" cy="12" r="1" fill="#C7F94B"/></svg> },
  { title: "Local SEO that ranks",       desc: "Optimised to show up when people in your area search for what you do.",                        svg: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C7F94B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 21s-7-5.5-7-11a7 7 0 0 1 14 0c0 5.5-7 11-7 11Z"/><circle cx="12" cy="10" r="2.5"/></svg> },
  { title: "Lead & booking forms",       desc: "Smart forms and click-to-call that send enquiries straight to your phone.",                    svg: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C7F94B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 8h8M8 12h8M8 16h5"/></svg> },
  { title: "Lightning fast & mobile",    desc: "Loads in under a second on any phone - where most of your customers are looking.",             svg: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C7F94B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z"/></svg> },
  { title: "WhatsApp & call integration", desc: "One tap to call or message. Built the way local customers actually want to reach you.",             svg: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C7F94B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.8 19.8 0 0 1-3.07-8.67A2 2 0 0 1 3.62 1h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.64a16 16 0 0 0 5.45 5.45l1-1a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92Z"/></svg> },
  { title: "Ongoing care",               desc: "Hosting, updates and edits handled for you - so your site never goes stale.",                  svg: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C7F94B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3 5 6v5c0 4.5 3 8 7 10 4-2 7-5.5 7-10V6l-7-3Z"/><path d="m9 12 2 2 4-4"/></svg> },
];

// const STATS = [
//   { val: "120+",   label: "Local businesses launched" },
//   { val: "2.4×",   label: "More leads on average" },
//   { val: "2-3 wks",label: "From start to launch" },
//   { val: "4.9★",   label: "Average client rating" },
// ];

// const TESTIMONIALS = [
//   { stars: 5, quote: "Within a month the phone was ringing from people who found us on Google. The new site finally looks like the quality of work we actually do.", name: "Mike R.", biz: "Polished Plumbing Co.", initials: "MR", avatarGrad: "linear-gradient(135deg,#2dd4bf,#0e7490)", initColor: "#04201d" },
//   { stars: 5, quote: "They sent a mockup before I paid anything. It was a no-brainer. New patients now book straight from the site - bookings are up 68%.", name: "Dr. Sara L.", biz: "Bright Smile Dental", initials: "SL", avatarGrad: "linear-gradient(135deg,#60a5fa,#1e40af)", initColor: "#08183a" },
//   { stars: 5, quote: "Fast, easy, and they handled everything. Tables are full on weekends now and reservations come right through the website.", name: "Gina T.", biz: "Nonna's Kitchen", initials: "GT", avatarGrad: "linear-gradient(135deg,#fbbf24,#b45309)", initColor: "#3a2406" },
// ];

// ── Three.js initialiser (returns cleanup fn) ─────────────────────────────────
function initThree(canvas) {
  const THREE = window.THREE;
  if (!THREE || !canvas) return null;
  const parent = canvas.parentElement;
  if (!parent) return null;
  let w = parent.clientWidth, h = parent.clientHeight;
  const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.setSize(w, h, false);
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(45, w / h, 0.1, 100);
  camera.position.set(0, 0, 6.4);
  const group = new THREE.Group(); scene.add(group);
  const accentMats = [];
  const HEX = "#C7F94B";

  const palettes = [
    { bg: ["#0e2a33","#0a1418"], bar: "#2dd4bf", text: "#dff7f4", btn: "#2dd4bf" },
    { bg: ["#eef4ff","#dbe7fb"], bar: "#3b82f6", text: "#1e3a5f", btn: "#3b82f6", light: true },
    { bg: ["#2a1a0f","#170d05"], bar: "#f59e0b", text: "#fbe7c6", btn: "#f59e0b" },
    { bg: ["#11141c","#0a0c11"], bar: HEX,       text: "#e8eef5", btn: HEX },
    { bg: ["#1a1030","#0d0820"], bar: "#9b7cff", text: "#e9e3ff", btn: "#9b7cff" },
    { bg: ["#0f1a14","#091109"], bar: "#67e8a3", text: "#dcf7e7", btn: "#67e8a3" },
    { bg: ["#1a1400","#0d0900"], bar: "#fbbf24", text: "#fef3c7", btn: "#fbbf24" },
    { bg: ["#150a1a","#0a060f"], bar: "#c084fc", text: "#f3e8ff", btn: "#c084fc" },
    { bg: ["#0a1a0a","#060d06"], bar: "#4ade80", text: "#dcfce7", btn: "#4ade80" },
    { bg: ["#0f1a0a","#080e05"], bar: "#84cc16", text: "#ecfccb", btn: "#84cc16" },
    { bg: ["#1a0e00","#0d0700"], bar: "#f97316", text: "#fff7ed", btn: "#f97316" },
  ];

  const makeScreen = (p) => {
    const cv = document.createElement("canvas"); cv.width = 360; cv.height = 232;
    const x = cv.getContext("2d");
    const g = x.createLinearGradient(0, 0, 360, 232);
    g.addColorStop(0, p.bg[0]); g.addColorStop(1, p.bg[1]);
    x.fillStyle = g; x.fillRect(0, 0, 360, 232);
    x.fillStyle = p.bar; x.fillRect(0, 0, 360, 30);
    x.fillStyle = "rgba(255,255,255,.9)"; x.beginPath(); x.arc(18, 15, 5, 0, 7); x.fill();
    x.fillStyle = p.light ? "rgba(20,40,70,.45)" : "rgba(255,255,255,.5)";
    x.fillRect(36, 11, 64, 8); x.fillRect(258, 9, 84, 12);
    x.fillStyle = p.text; x.fillRect(28, 64, 214, 18); x.fillRect(28, 92, 150, 18);
    x.fillStyle = p.light ? "rgba(30,58,95,.3)" : "rgba(255,255,255,.32)";
    x.fillRect(28, 122, 252, 9); x.fillRect(28, 137, 188, 9);
    x.fillStyle = p.btn;
    if (x.roundRect) { x.beginPath(); x.roundRect(28, 158, 98, 30, 8); x.fill(); } else { x.fillRect(28, 158, 98, 30); }
    for (let k = 0; k < 3; k++) {
      x.fillStyle = p.light ? "#ffffff" : "rgba(255,255,255,.09)";
      x.fillRect(28 + k * 108, 204, 96, 18);
    }
    const tex = new THREE.CanvasTexture(cv); tex.anisotropy = 4; return tex;
  };

  const carouselSites = SITES.filter(s => !s.no3d); const W = 1.8, H = 1.16, D = 0.08, N = carouselSites.length, radius = 2.4;
  const loader = new THREE.TextureLoader();
  const siteUrls = carouselSites.map(s => s.url);
  const panels = [];
  for (let i = 0; i < N; i++) {
    const card = new THREE.Group();
    const fallbackTex = makeScreen(palettes[i % palettes.length]);
    const faceMat = new THREE.MeshStandardMaterial({ map: fallbackTex, emissiveMap: fallbackTex, emissive: 0xffffff, emissiveIntensity: 0.16, metalness: 0.0, roughness: 0.6 });

    if (i < siteUrls.length) {
      const screenshotUrl = `https://image.thum.io/get/width/720/crop/464/noanimate/${siteUrls[i]}`;
      loader.load(screenshotUrl, (realTex) => {
        realTex.flipY = true;
        faceMat.map = realTex;
        faceMat.emissiveMap = realTex;
        faceMat.emissiveIntensity = 0.08;
        faceMat.needsUpdate = true;
      }, undefined, () => {});
    }

    const sideMat = new THREE.MeshStandardMaterial({ color: 0x0b0e13, metalness: 0.65, roughness: 0.32 });
    const geom = new THREE.BoxGeometry(W, H, D);
    card.add(new THREE.Mesh(geom, [sideMat, sideMat, sideMat, sideMat, faceMat, faceMat]));
    const edgeMat = new THREE.LineBasicMaterial({ color: HEX, transparent: true, opacity: 0.7 });
    accentMats.push(edgeMat);
    card.add(new THREE.LineSegments(new THREE.EdgesGeometry(geom), edgeMat));
    const angle = (i / N) * Math.PI * 2;
    const baseY = (i - (N - 1) / 2) * 0.34;
    card.position.set(Math.cos(angle) * radius, baseY, Math.sin(angle) * radius);
    card.rotation.y = -angle + Math.PI / 2;
    group.add(card);
    panels.push({ card, baseY, phase: i * 0.9, tilt: (i % 2 ? 1 : -1) * 0.05 });
  }

  const shapes = [];
  const shapeGeoms = [new THREE.OctahedronGeometry(0.3), new THREE.IcosahedronGeometry(0.26, 0), new THREE.TetrahedronGeometry(0.34), new THREE.TorusGeometry(0.24, 0.09, 12, 24)];
  const shapePos = [[-3.0, 1.9, 0.8], [3.0, -1.7, 1.0], [-2.6, -1.9, 1.4], [2.7, 2.0, 0.4]];
  for (let i = 0; i < shapeGeoms.length; i++) {
    const m = new THREE.MeshStandardMaterial({ color: HEX, emissive: HEX, emissiveIntensity: 0.5, metalness: 0.5, roughness: 0.3 });
    accentMats.push(m);
    const s = new THREE.Mesh(shapeGeoms[i], m);
    s.position.set(shapePos[i][0], shapePos[i][1], shapePos[i][2]);
    scene.add(s);
    shapes.push({ mesh: s, sp: 0.4 + i * 0.15, baseY: shapePos[i][1] });
  }

  scene.add(new THREE.AmbientLight(0x4a5468, 0.85));
  const accentLight = new THREE.PointLight(HEX, 11, 70); accentLight.position.set(3, 3, 5); scene.add(accentLight);
  const blueLight = new THREE.PointLight(0x5B8CFF, 8, 70); blueLight.position.set(-4, -2, 4); scene.add(blueLight);
  const whiteLight = new THREE.PointLight(0xffffff, 5, 70); whiteLight.position.set(0, 4, -2); scene.add(whiteLight);

  const pcount = 140; const pg = new THREE.BufferGeometry(); const arr = new Float32Array(pcount * 3);
  for (let i = 0; i < pcount * 3; i++) arr[i] = (Math.random() - 0.5) * 14;
  pg.setAttribute("position", new THREE.BufferAttribute(arr, 3));
  const pts = new THREE.Points(pg, new THREE.PointsMaterial({ color: 0x8A929E, size: 0.035, transparent: true, opacity: 0.5 }));
  scene.add(pts);

  let mx = 0, my = 0;
  const onMove = (e) => { mx = e.clientX / window.innerWidth - 0.5; my = e.clientY / window.innerHeight - 0.5; };
  window.addEventListener("mousemove", onMove);
  const clock = new THREE.Clock();
  let raf;
  const animate = () => {
    raf = requestAnimationFrame(animate);
    const t = clock.getElapsedTime();
    group.rotation.y = t * 0.2 + mx * 0.5;
    group.rotation.x = my * 0.22 + Math.sin(t * 0.25) * 0.04;
    panels.forEach(p => { p.card.position.y = p.baseY + Math.sin(t * 0.9 + p.phase) * 0.08; p.card.rotation.z = Math.sin(t * 0.5 + p.phase) * p.tilt; });
    shapes.forEach(s => { s.mesh.rotation.x += 0.006; s.mesh.rotation.y += 0.008; s.mesh.position.y = s.baseY + Math.sin(t * s.sp) * 0.25; });
    pts.rotation.y = t * 0.02;
    accentLight.position.x = Math.sin(t * 0.7) * 4; accentLight.position.z = Math.cos(t * 0.7) * 4;
    blueLight.position.x = Math.cos(t * 0.5) * 4; blueLight.position.z = Math.sin(t * 0.5) * 4;
    camera.position.x = mx * 0.5; camera.position.y = -my * 0.5; camera.lookAt(0, 0, 0);
    renderer.render(scene, camera);
  };
  animate();

  const onResize = () => { w = parent.clientWidth; h = parent.clientHeight; camera.aspect = w / h; camera.updateProjectionMatrix(); renderer.setSize(w, h, false); };
  window.addEventListener("resize", onResize);

  return () => { cancelAnimationFrame(raf); window.removeEventListener("mousemove", onMove); window.removeEventListener("resize", onResize); renderer.dispose(); };
}

// ── Helpers ───────────────────────────────────────────────────────────────────
const tiltOn = (e) => {
  const c = e.currentTarget, r = c.getBoundingClientRect();
  const px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
  c.style.transform = `perspective(1000px) rotateY(${px * 7}deg) rotateX(${-py * 7}deg) translateY(-4px)`;
};
const tiltOff = (e) => { e.currentTarget.style.transform = "perspective(1000px) rotateY(0) rotateX(0) translateY(0)"; };

// ── Main component ────────────────────────────────────────────────────────────
const COUNTRIES = ["United States","United Kingdom","Canada","Australia","India","UAE","Singapore","South Africa","New Zealand","Germany","France","Netherlands","Ireland","Sweden","Norway","Denmark","Switzerland","Italy","Spain","Portugal","Brazil","Mexico","Argentina","Colombia","Philippines","Malaysia","Indonesia","Pakistan","Nigeria","Kenya","Other"];

function CountrySelect({ value, onChange, hasError }) {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const filtered = query ? COUNTRIES.filter(c => c.toLowerCase().includes(query.toLowerCase())) : COUNTRIES;
  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) { setOpen(false); setQuery(""); } };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);
  const select = (country) => { onChange({ target: { value: country } }); setOpen(false); setQuery(""); };
  return (
    <div ref={wrapRef} className="dv2-cs-wrap">
      <div className={`dv2-input dv2-cs-trigger${hasError ? " dv2-input--err" : ""}${open ? " dv2-cs-trigger--open" : ""}`} onClick={() => setOpen(o => !o)}>
        {open
          ? <input autoFocus className="dv2-cs-search" placeholder="Type to search..." value={query} onChange={e => setQuery(e.target.value)} onClick={e => e.stopPropagation()} />
          : <span className={value ? "dv2-cs-value" : "dv2-cs-placeholder"}>{value || "Select your country"}</span>}
        <svg className={`dv2-cs-chevron${open ? " dv2-cs-chevron--open" : ""}`} width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 1l5 5 5-5" stroke="#9AA3AF" strokeWidth="1.5" strokeLinecap="round"/></svg>
      </div>
      {open && (
        <div className="dv2-cs-dropdown">
          {filtered.length === 0
            ? <div className="dv2-cs-empty">No results</div>
            : filtered.map(c => <div key={c} className={`dv2-cs-option${value === c ? " dv2-cs-option--active" : ""}`} onMouseDown={() => select(c)}>{c}</div>)}
        </div>
      )}
    </div>
  );
}
function PrivacyModal({ onClose }) {
  return (
    <div className="dv2-modal-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="dv2-pm">
        <div className="dv2-pm__header">
          <span className="dv2-pm__title">Privacy Policy</span>
          <button type="button" className="dv2-pm__close" onClick={onClose}>✕</button>
        </div>
        <div className="dv2-pm__body">
          <p className="dv2-pm__updated">Last updated: June 2026</p>
          <p>Developed By Shashank ("we", "us") operates develop.shashankupadhyaya.com.</p>
          <h4>Information we collect</h4>
          <p>When you submit our contact form we collect: your name, business name, phone or email, WhatsApp number (optional), country, and business description. We also collect basic usage data via Google Analytics.</p>
          <h4>How we use your information</h4>
          <p>We use your contact details solely to prepare and send your free website mockup, follow up about our services, and respond to enquiries. We do not sell or share your data with third parties except the service providers we use to operate (Google Firebase for form storage, Google Analytics for usage insights).</p>
          <h4>Data storage</h4>
          <p>Submissions are stored securely in Google Firebase Firestore (United States).</p>
          <h4>Your rights</h4>
          <p>You may request access to or deletion of your data at any time by emailing <a href="mailto:shashank@meeraq.com">shashank@meeraq.com</a>.</p>
          <h4>Contact</h4>
          <p><a href="mailto:shashank@meeraq.com">shashank@meeraq.com</a></p>
        </div>
      </div>
    </div>
  );
}
export default function Develop() {
  const [form, setForm] = useState({ name: "", business: "", contact: "", whatsapp: "", country: "", what: "" });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [openFaq, setOpenFaq] = useState(-1);
  const [showFab, setShowFab] = useState(false);
  const [enquiryCount, setEnquiryCount] = useState(null);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const canvasRef = useRef(null);

  const scrollToForm = useCallback(() => {
    const el = document.getElementById("enquiry");
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 16, behavior: "smooth" });
  }, []);

  const field = (k) => (e) => { setForm(s => ({ ...s, [k]: e.target.value })); setErrors(s => ({ ...s, [k]: false })); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!form.name.trim()) errs.name = true;
    if (!form.business.trim()) errs.business = true;
    if (!form.contact.trim()) errs.contact = true;
    if (!form.country) errs.country = true;
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setSubmitting(true);
    setSubmitError("");
    try {
      await addDoc(collection(db, "develop_enquiries"), {
        ...form,
        submittedAt: serverTimestamp(),
      });
      setSubmitted(true);
      try { if (window.gtag) window.gtag("event", "generate_lead", { event_category: "form", event_label: "mockup_request" }); } catch (_) {}
      try { if (window.gtag) window.gtag("event", "conversion", { send_to: "AW-434960518/M9flCK6TosYcEIbxs88B" }); } catch (_) {}
      setEnquiryCount(n => n !== null ? n + 1 : 1);
    } catch (err) {
      console.error("Enquiry submit failed:", err);
      setSubmitError("Something went wrong. Please try again or reach out directly.");
    } finally {
      setSubmitting(false);
    }
  };

  // Scroll reveal
  useEffect(() => {
    const els = [...document.querySelectorAll("[data-reveal]")];
    els.forEach(el => { el.style.opacity = "0"; el.style.transform = "translateY(26px)"; el.style.transition = "opacity .7s ease, transform .7s ease"; });
    let pending = [...els];
    const check = () => {
      const vh = window.innerHeight;
      pending = pending.filter(el => {
        if (el.getBoundingClientRect().top < vh * 0.9) { el.style.opacity = "1"; el.style.transform = "none"; return false; }
        return true;
      });
    };
    window.addEventListener("scroll", check, { passive: true });
    requestAnimationFrame(() => requestAnimationFrame(check));
    setTimeout(check, 400);
    return () => window.removeEventListener("scroll", check);
  }, []);

  // FAB visibility
  useEffect(() => {
    const fn = () => setShowFab(window.scrollY > 700);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  // Enquiry counter
  useEffect(() => {
    getCountFromServer(collection(db, "develop_enquiries"))
      .then(s => setEnquiryCount(s.data().count))
      .catch(() => {});
  }, []);

  // Three.js
  useEffect(() => {
    let cleanup = null;
    let cancelled = false;
    const run = () => { if (!cancelled) { try { cleanup = initThree(canvasRef.current); } catch (e) { console.warn("3D init failed", e); } } };
    if (window.THREE) { run(); }
    else {
      const s = document.createElement("script");
      s.src = "https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js";
      s.onload = run; document.head.appendChild(s);
    }
    return () => { cancelled = true; if (cleanup) cleanup(); };
  }, []);

  return (
    <div className="dv2">
      <style>{CSS}</style>

      {/* ── NAV ── */}
      <NavBar scrollToForm={scrollToForm} />

      {/* ── HERO ── */}
      <section id="top" className="dv2-hero">
        <div className="dv2-hero__glow" />
        <div className="dv2-wrap dv2-hero__inner">
          <div className="dv2-hero__left" data-reveal>
            <div className="dv2-badge">
              <span className="dv2-badge__dot" />
              Free homepage mockup before you pay a cent
            </div>
            <h1 className="dv2-h1">
              Websites that turn local searches into <span className="dv2-lime">booked jobs.</span>
            </h1>
            <p className="dv2-hero__sub">
              We design and build fast, custom websites for local service businesses - so you stop losing customers to competitors who simply look more legit online.
            </p>
            <div className="dv2-hero__cta">
              <button className="dv2-btn dv2-btn--lime" onClick={scrollToForm}>
                Get my free mockup <span>→</span>
              </button>
              <a href="#work" className="dv2-btn dv2-btn--ghost">See our work</a>
            </div>
            <div className="dv2-trust-row">
              <span><span className="dv2-lime">✓</span> No upfront cost</span>
              <span><span className="dv2-lime">✓</span> Live in 1 week</span>
              <span><span className="dv2-lime">✓</span> Built to rank on Google</span>
            </div>
          </div>
          <div className="dv2-hero__right">
            <canvas ref={canvasRef} className="dv2-hero__canvas" />
            <div className="dv2-float dv2-float--bottom">
              <span className="dv2-float__icon">✓</span>
              <div>
                <div className="dv2-float__label">{enquiryCount > 5 ? `${enquiryCount} mockups sent` : "Free mockup"}</div>
                <div className="dv2-float__val">No upfront cost</div>
              </div>
            </div>
            <div className="dv2-float dv2-float--top">
              <span className="dv2-float__icon">⚡</span>
              <div>
                <div className="dv2-float__label">Launched in</div>
                <div className="dv2-float__val">7 days</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── MARQUEE ── */}
      <div className="dv2-marquee-wrap">
        <div className="dv2-marquee-label">Trusted by local businesses across every trade</div>
        <div className="dv2-marquee">
          {[0,1].map(k => (
            <div key={k} className="dv2-marquee__track" aria-hidden={k === 1 ? "true" : undefined}>
              {["PLUMBING","HVAC","DENTAL","LANDSCAPING","ELECTRICAL","ROOFING","SALON","LEGAL"].map(t => (
                <span key={t} className="dv2-marquee__item">{t}</span>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* ── WORK ── */}
      <section id="work" className="dv2-section">
        <div className="dv2-wrap">
          <div className="dv2-section__head" data-reveal>
            <div className="dv2-overline">Recent work</div>
            <h2 className="dv2-h2">Sites that actually look like the business deserves the call.</h2>
            <p className="dv2-section__sub">A clean, fast, trustworthy site is the difference between a customer calling you or scrolling to the next result.</p>
          </div>
          <div className="dv2-work-grid">
            {SITES.map((site, i) => (
              <div key={site.id} className="dv2-work-card" data-reveal onMouseMove={tiltOn} onMouseLeave={tiltOff} style={{ transitionDelay: `${i * 0.06}s` }}>
                <div className="dv2-work-card__browser">
                  <span className="dv2-dot" style={{ background: "#ff5f57" }} />
                  <span className="dv2-dot" style={{ background: "#febc2e" }} />
                  <span className="dv2-dot" style={{ background: "#28c840" }} />
                  <span className="dv2-work-card__urlbar" />
                </div>
                <div className="dv2-work-card__preview">
                  <img
                    src={`https://image.thum.io/get/width/720/crop/464/noanimate/${site.url}`}
                    alt={site.niche}
                    loading="lazy"
                    className="dv2-work-card__img"
                    onError={(e) => { e.target.style.display = "none"; }}
                  />
                </div>
                <div className="dv2-work-card__body">
                  <div>
                    <div className="dv2-work-card__name">{site.niche}</div>
                  </div>
                  <a href={site.url} target="_blank" rel="noreferrer" style={{ textAlign: "right", textDecoration: "none" }}>
                    <div className="dv2-lime" style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 13 }}>View Live ↗</div>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SERVICES ── */}
      <section id="services" className="dv2-section dv2-section--tinted">
        <div className="dv2-wrap">
          <div className="dv2-section__head" data-reveal>
            <div className="dv2-overline">What you get</div>
            <h2 className="dv2-h2">Everything a local business needs to win the click - and the call.</h2>
          </div>
          <div className="dv2-services-grid">
            {SERVICES.map((s, i) => (
              <div key={i} className="dv2-svc-card" data-reveal onMouseMove={tiltOn} onMouseLeave={tiltOff} style={{ transitionDelay: `${i * 0.05}s` }}>
                <div className="dv2-svc-icon">{s.svg}</div>
                <h3 className="dv2-svc-card__title">{s.title}</h3>
                <p className="dv2-svc-card__desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PROCESS ── */}
      <section id="process" className="dv2-section">
        <div className="dv2-wrap">
          <div className="dv2-section__head" data-reveal>
            <div className="dv2-overline">How it works</div>
            <h2 className="dv2-h2">Three steps. Zero risk to start.</h2>
          </div>
          <div className="dv2-process-grid">
            {[
              { n: "01", title: "See it first, free",  desc: "Tell us about your business and we'll design a custom homepage mockup - before you spend a thing." },
              { n: "02", title: "Approve & we build",  desc: "Love it? We build the full site, wire up your forms and SEO, and handle every technical detail." },
              { n: "03", title: "Launch & grow",       desc: "Go live in 1 week and start turning searches into booked jobs. We keep it running." },
            ].map((p, i) => (
              <div key={i} className="dv2-process-card" data-reveal style={{ transitionDelay: `${i * 0.1}s` }}>
                <div className="dv2-process-num">{p.n}</div>
                <h3 className="dv2-process-card__title">{p.title}</h3>
                <p className="dv2-process-card__desc">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── STATS (hidden until we have real numbers) ──
      <div className="dv2-stats-strip">
        <div className="dv2-wrap dv2-stats-strip__row">
          {STATS.map((s, i) => (
            <div key={i} className="dv2-stat" data-reveal style={{ transitionDelay: `${i * 0.08}s` }}>
              <div className="dv2-stat__val">{s.val}</div>
              <div className="dv2-stat__label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
      ── */}

      {/* ── TESTIMONIALS (hidden until we have real clients) ──
      <section className="dv2-section">
        <div className="dv2-wrap">
          <div className="dv2-section__head" data-reveal>
            <div className="dv2-overline">In their words</div>
            <h2 className="dv2-h2">Owners who stopped losing jobs online.</h2>
          </div>
          <div className="dv2-testi-grid">
            {TESTIMONIALS.map((t, i) => (
              <div key={i} className="dv2-testi-card" data-reveal style={{ transitionDelay: `${i * 0.08}s` }}>
                <div className="dv2-lime" style={{ fontSize: 16, marginBottom: 16 }}>{"★".repeat(t.stars)}</div>
                <p className="dv2-testi-card__quote">"{t.quote}"</p>
                <div className="dv2-testi-card__author">
                  <span className="dv2-testi-card__avatar" style={{ background: t.avatarGrad, color: t.initColor }}>{t.initials}</span>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 15 }}>{t.name}</div>
                    <div style={{ color: "#7F8794", fontSize: 13 }}>{t.biz}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      ── */}

      {/* ── ENQUIRY FORM ── */}
      <section id="enquiry" className="dv2-section dv2-section--form">
        <div className="dv2-form-glow" />
        <div className="dv2-wrap dv2-form-grid">
          <div data-reveal>
            <div className="dv2-overline">Free mockup</div>
            <h2 className="dv2-h2" style={{ marginBottom: 18 }}>Get a free homepage design - before you pay anything.</h2>
            <p style={{ fontSize: 17, lineHeight: 1.6, color: "#A7AFBB", marginBottom: 28 }}>
              Tell us a little about your business. We'll design a custom mockup and send it over within one business day. No cost, no obligation.
            </p>
            <div className="dv2-form-benefits">
              {["See a real design of your site - not a template", "Fixed, transparent pricing - never hourly", "You own everything - no lock-in, ever"].map((b, i) => (
                <div key={i} className="dv2-form-benefit">
                  <span className="dv2-form-benefit__check">✓</span>
                  <span style={{ color: "#C9D0DA", fontSize: 15, lineHeight: 1.5 }}>{b}</span>
                </div>
              ))}
            </div>
            <div className="dv2-urgency">
              <span className="dv2-badge__dot" />
              Currently accepting new clients. We personally review every request and reply within 1 business day.
            </div>
          </div>

          <div className="dv2-form-card" data-reveal>
            {submitted ? (
              <div className="dv2-form-success">
                <div className="dv2-form-success__icon">✓</div>
                <h3 className="dv2-form-success__title">Got it - thank you!</h3>
                <p style={{ color: "#A7AFBB", fontSize: 16, lineHeight: 1.6, margin: "0 0 20px" }}>
                  We'll get to work on your free mockup and send it over within one business day. Keep an eye on your inbox.
                </p>
                <a href="https://wa.me/919111450451?text=Hi%2C%20I%20just%20submitted%20a%20mockup%20request%20and%20wanted%20to%20connect" target="_blank" rel="noreferrer" className="dv2-btn dv2-btn--full" style={{ background: "#25D366", color: "#fff", fontSize: 15, borderRadius: 12, textDecoration: "none" }}>
                  Chat on WhatsApp →
                </a>
              </div>
            ) : (
              <form onSubmit={handleSubmit} noValidate>
                {enquiryCount > 5 && (
                  <div className="dv2-social-proof">
                    <span className="dv2-social-proof__dot" />
                    {enquiryCount} businesses have already requested a mockup
                  </div>
                )}
                {[
                  { key: "name",     label: "Your name",         placeholder: "Jane Smith",                              type: "text",  required: true },
                  { key: "business", label: "Business name",     placeholder: "Smith & Co. Plumbing",                    type: "text",  required: true },
                  { key: "contact",  label: "Phone or email",    placeholder: "(555) 123-4567 or you@email.com",          type: "text",  required: true },
                  { key: "whatsapp", label: "WhatsApp number",   placeholder: "+1 (555) 123-4567",                        type: "tel",    required: false, optional: true },
                  { key: "country",  label: "Country",                    placeholder: "",                                         type: "select", required: true },
                  { key: "what",     label: "What does your business do?", placeholder: "e.g. emergency plumbing in Austin, TX",    type: "text",   required: false, optional: true },
                ].map(({ key, label, placeholder, type, required, optional }) => (
                  <div key={key} className="dv2-form-field">
                    <label className="dv2-form-label">
                      {key === "whatsapp" && <span className="dv2-wa-dot" />}{label}{optional && <span className="dv2-form-opt"> (optional)</span>}
                    </label>
                    {type === "select" ? (
                      <CountrySelect value={form[key]} onChange={field(key)} hasError={errors[key]} />
                    ) : (
                      <input
                        type={type}
                        className={`dv2-input${errors[key] ? " dv2-input--err" : ""}`}
                        placeholder={placeholder}
                        value={form[key]}
                        onChange={field(key)}
                        required={required}
                      />
                    )}
                    {errors[key] && <div className="dv2-field-err">{key === "contact" ? "We need a way to reach you" : key === "country" ? "Please select your country" : `Please enter your ${key === "business" ? "business name" : key}`}</div>}
                  </div>
                ))}
                <button type="submit" className="dv2-btn dv2-btn--lime dv2-btn--full" disabled={submitting}>
                  {submitting ? "Sending…" : "Send me my free mockup →"}
                </button>
                {submitError && <p style={{ margin: "8px 0 0", fontSize: 12.5, color: "#f87171", textAlign: "center" }}>{submitError}</p>}
                <div className="dv2-wa-alt">
                  <span>Prefer to talk first?</span>{" "}
                  <a href="https://wa.me/919111450451?text=Hi%2C%20I%27d%20like%20a%20free%20website%20mockup%20for%20my%20business" target="_blank" rel="noreferrer" className="dv2-wa-alt__link">
                    WhatsApp us →
                  </a>
                </div>
                <p className="dv2-form-note">
                  No cost, no obligation. We reply within 1 business day.{" "}
                  <button type="button" onClick={() => setShowPrivacy(true)} className="dv2-privacy-link">Privacy Policy</button>
                </p>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section id="faq" className="dv2-section">
        <div className="dv2-wrap dv2-wrap--narrow">
          <div className="dv2-section__head" data-reveal style={{ textAlign: "center" }}>
            <div className="dv2-overline">Questions</div>
            <h2 className="dv2-h2">Everything you might be wondering.</h2>
          </div>
          <div data-reveal className="dv2-faq-list">
            {FAQ_DATA.map((f, i) => (
              <div key={i} className="dv2-faq-item">
                <button className="dv2-faq-q" onClick={() => setOpenFaq(openFaq === i ? -1 : i)}>
                  <span>{f.q}</span>
                  <span className="dv2-faq-sign dv2-lime">{openFaq === i ? "-" : "+"}</span>
                </button>
                {openFaq === i && <div className="dv2-faq-a">{f.a}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA BANNER ── */}
      <section className="dv2-section" style={{ paddingBottom: "clamp(72px,9vw,110px)" }}>
        <div className="dv2-wrap" data-reveal>
          <div className="dv2-cta-banner">
            <div className="dv2-cta-banner__glow" />
            <h2 className="dv2-cta-banner__title">
              Your competitors already look better online.<br />Let's fix that - for free.
            </h2>
            <p className="dv2-cta-banner__sub">
              Get a custom homepage mockup with no cost and no obligation. See exactly what your new site could look like.
            </p>
            <button className="dv2-btn dv2-btn--lime" onClick={scrollToForm}>
              Get my free mockup →
            </button>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="dv2-footer">
        <div className="dv2-wrap dv2-footer__inner">
          <div className="dv2-footer__brand">
            <img src={logo} alt="Developed By Shashank" className="dv2-logo-img" />
          </div>
          <span className="dv2-footer__copy">Custom websites for local service businesses.</span>
          <span className="dv2-footer__copy">© 2026 Shashank Upadhyaya. All rights reserved.</span>
        </div>
      </footer>

      {/* ── FAB ── */}
      <button
        className="dv2-fab"
        onClick={scrollToForm}
        style={{ opacity: showFab ? 1 : 0, transform: showFab ? "translateY(0)" : "translateY(20px)", pointerEvents: showFab ? "auto" : "none" }}
      >
        Get free mockup →
      </button>
      {showPrivacy && <PrivacyModal onClose={() => setShowPrivacy(false)} />}
    </div>
  );
}

// ── Nav ───────────────────────────────────────────────────────────────────────
function NavBar({ scrollToForm }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);
  const close = () => setOpen(false);
  return (
    <nav className={`dv2-nav${scrolled ? " dv2-nav--scrolled" : ""}`}>
      <div className="dv2-wrap dv2-nav__inner">
        <a href="https://develop.shashankupadhyaya.com" className="dv2-logo">
          <img src={logo} alt="Developed By Shashank" className="dv2-logo-img" />
        </a>
        <div className={`dv2-nav__links${open ? " is-open" : ""}`}>
          {[["#work","Work"],["#services","Services"],["#process","Process"],["#faq","FAQ"]].map(([href, label]) => (
            <a key={href} href={href} onClick={close}>{label}</a>
          ))}
        </div>
        <button className="dv2-btn dv2-btn--lime dv2-nav__cta" onClick={() => { scrollToForm(); close(); }}>
          Get free mockup
        </button>
        <button className="dv2-burger" onClick={() => setOpen(o => !o)} aria-label="Menu">
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}

// ── CSS ───────────────────────────────────────────────────────────────────────
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=Manrope:wght@400;500;600;700;800&display=swap');

  .dv2 {
    --acc: #C7F94B;
    --ink: #0A0B0D;
    --bg: #0A0B0D;
    --card: #0E1116;
    --input: #0A0C10;
    --text: #EDEFF2;
    --muted: #9AA3AF;
    --border: rgba(255,255,255,0.08);
    background: var(--bg);
    color: var(--text);
    font-family: 'Manrope', sans-serif;
    font-size: 15px;
    min-height: 100vh;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
  }
  .dv2 *, .dv2 *::before, .dv2 *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .dv2 a { color: inherit; text-decoration: none; }
  .dv2 button { font-family: inherit; cursor: pointer; }

  /* Layout */
  .dv2-wrap { max-width: 1200px; margin: 0 auto; padding: 0 24px; }
  .dv2-wrap--narrow { max-width: 820px; margin: 0 auto; padding: 0 24px; }

  /* Colours */
  .dv2-lime { color: var(--acc); }

  /* Section */
  .dv2-section { padding: clamp(72px,9vw,120px) 0; }
  .dv2-section--tinted { background: linear-gradient(180deg,transparent,rgba(255,255,255,0.015),transparent); }
  .dv2-section--form { position: relative; }
  .dv2-section__head { max-width: 640px; margin-bottom: 54px; }
  .dv2-overline { font-size: 13px; letter-spacing: 0.16em; color: var(--acc); font-weight: 700; text-transform: uppercase; margin-bottom: 14px; }
  .dv2-h2 { font-family: 'Space Grotesk', sans-serif; font-weight: 700; font-size: clamp(28px,4.4vw,46px); line-height: 1.06; letter-spacing: -0.02em; }
  .dv2-section__sub { font-size: 17px; line-height: 1.55; color: var(--muted); margin-top: 12px; }

  /* Buttons */
  .dv2-btn { display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 13px 22px; border-radius: 12px; font-size: 15px; font-weight: 700; border: none; cursor: pointer; transition: transform .15s ease, box-shadow .15s ease, background .15s ease; }
  .dv2-btn--lime { background: var(--acc); color: var(--ink); box-shadow: 0 10px 36px rgba(199,249,75,0.28); }
  .dv2-btn--lime:hover { transform: translateY(-2px); box-shadow: 0 16px 44px rgba(199,249,75,0.38); }
  .dv2-btn--lime:disabled { opacity: 0.6; cursor: not-allowed; transform: none; box-shadow: none; }
  .dv2-btn--ghost { background: transparent; color: var(--text); border: 1px solid rgba(255,255,255,0.16); padding: 13px 22px; border-radius: 12px; }
  .dv2-btn--ghost:hover { background: rgba(255,255,255,0.05); }
  .dv2-btn--full { width: 100%; font-size: 16px; padding: 16px; border-radius: 13px; }

  /* ── Nav ── */
  .dv2-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 60; padding: 0; transition: background .3s, border-color .3s, backdrop-filter .3s; }
  .dv2-nav--scrolled { background: rgba(10,11,13,0.92); backdrop-filter: blur(20px); border-bottom: 1px solid var(--border); }
  .dv2-nav__inner { display: flex; align-items: center; justify-content: space-between; height: 64px; gap: 20px; }
  .dv2-logo { display: flex; align-items: center; }
  .dv2-logo-img { height: 56px; width: auto; display: block; object-fit: contain; }
  .dv2-nav__links { display: flex; align-items: center; gap: 32px; }
  .dv2-nav__links a { font-size: 15px; font-weight: 500; color: var(--muted); transition: color .2s; }
  .dv2-nav__links a:hover { color: var(--text); }
  .dv2-nav__cta { padding: 10px 18px; font-size: 14px; border-radius: 11px; }
  .dv2-burger { display: none; background: none; border: none; flex-direction: column; gap: 5px; padding: 8px; }
  .dv2-burger span { display: block; width: 22px; height: 2px; background: var(--text); border-radius: 2px; }

  /* ── Hero ── */
  .dv2-hero { position: relative; min-height: 100vh; display: flex; align-items: center; padding: 120px 0 60px; }
  .dv2-hero__glow { position: absolute; inset: 0; background: radial-gradient(60% 50% at 72% 42%, rgba(199,249,75,0.13), transparent 70%), radial-gradient(50% 50% at 20% 80%, rgba(91,140,255,0.10), transparent 70%); pointer-events: none; }
  .dv2-hero__inner { display: flex; flex-wrap: wrap; align-items: center; gap: 32px; position: relative; }
  .dv2-hero__left { flex: 1 1 480px; min-width: 300px; }
  .dv2-hero__right { flex: 1 1 420px; min-width: 300px; height: clamp(360px,46vw,560px); position: relative; }
  .dv2-hero__canvas { width: 100%; height: 100%; display: block; }
  .dv2-badge { display: inline-flex; align-items: center; gap: 9px; border: 1px solid rgba(255,255,255,0.12); background: rgba(255,255,255,0.03); padding: 7px 14px; border-radius: 999px; font-size: 13px; font-weight: 600; color: #C9D0DA; margin-bottom: 26px; }
  .dv2-badge__dot { width: 8px; height: 8px; border-radius: 50%; background: var(--acc); box-shadow: 0 0 12px var(--acc); flex-shrink: 0; }
  .dv2-h1 { font-family: 'Space Grotesk', sans-serif; font-weight: 700; font-size: clamp(40px,6vw,68px); line-height: 1.02; letter-spacing: -0.03em; margin-bottom: 22px; }
  .dv2-hero__sub { font-size: clamp(17px,2.2vw,20px); line-height: 1.55; color: #A7AFBB; max-width: 540px; margin-bottom: 34px; }
  .dv2-hero__cta { display: flex; flex-wrap: wrap; gap: 14px; margin-bottom: 30px; }
  .dv2-trust-row { display: flex; flex-wrap: wrap; gap: 18px 26px; color: #7F8794; font-size: 14px; font-weight: 500; }
  .dv2-trust-row span { display: inline-flex; align-items: center; gap: 8px; }
  .dv2-float { position: absolute; background: rgba(16,19,24,0.85); backdrop-filter: blur(8px); border: 1px solid rgba(255,255,255,0.1); border-radius: 14px; padding: 13px 16px; display: flex; align-items: center; gap: 11px; box-shadow: 0 18px 40px rgba(0,0,0,0.45); }
  .dv2-float--bottom { left: 6%; bottom: 8%; animation: dv2-float 6s ease-in-out infinite; }
  .dv2-float--top { right: 2%; top: 12%; animation: dv2-float 7s ease-in-out infinite 0.8s; }
  .dv2-float__icon { width: 34px; height: 34px; border-radius: 9px; background: rgba(199,249,75,0.18); display: flex; align-items: center; justify-content: center; color: var(--acc); font-weight: 800; }
  .dv2-float__label { font-size: 13px; color: var(--muted); }
  .dv2-float__val { font-family: 'Space Grotesk', sans-serif; font-weight: 700; font-size: 17px; }
  @keyframes dv2-float { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-12px); } }

  /* ── Marquee ── */
  .dv2-marquee-wrap { border-top: 1px solid var(--border); border-bottom: 1px solid var(--border); padding: 26px 0; overflow: hidden; }
  .dv2-marquee-label { text-align: center; font-size: 12px; letter-spacing: 0.18em; color: #5b6472; font-weight: 700; margin-bottom: 18px; text-transform: uppercase; }
  .dv2-marquee { display: flex; width: max-content; animation: dv2-marquee 32s linear infinite; gap: 56px; }
  .dv2-marquee__track { display: flex; gap: 56px; }
  .dv2-marquee__item { font-family: 'Space Grotesk', sans-serif; font-weight: 700; font-size: 17px; color: #6a727f; letter-spacing: 0.04em; }
  @keyframes dv2-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }

  /* ── Work cards ── */
  .dv2-work-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  @media (max-width: 900px) { .dv2-work-grid { grid-template-columns: repeat(2, 1fr); } }
  @media (max-width: 580px) { .dv2-work-grid { grid-template-columns: 1fr; } }
  .dv2-work-card { border: 1px solid var(--border); border-radius: 18px; overflow: hidden; background: var(--card); transition: transform .2s ease; }
  .dv2-work-card__browser { background: #15181e; padding: 11px 14px; display: flex; align-items: center; gap: 8px; border-bottom: 1px solid rgba(255,255,255,0.06); }
  .dv2-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; display: block; }
  .dv2-work-card__urlbar { margin-left: 8px; flex: 1; background: #0b0d11; border-radius: 6px; height: 20px; display: block; }
  .dv2-work-card__preview { height: 230px; overflow: hidden; position: relative; background: #0e1116; }
  .dv2-work-card__img { width: 100%; height: 100%; object-fit: cover; object-position: top left; display: block; transition: transform 0.4s ease; }
  .dv2-work-card:hover .dv2-work-card__img { transform: scale(1.04); }
  .dv2-work-card__body { padding: 18px 20px; display: flex; align-items: center; justify-content: space-between; }
  .dv2-work-card__name { font-weight: 700; font-size: 16px; }
  .dv2-work-card__niche { color: #7F8794; font-size: 13px; }

  /* ── Services ── */
  .dv2-services-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(min(290px,100%),1fr)); gap: 18px; }
  .dv2-svc-card { border: 1px solid var(--border); background: var(--card); border-radius: 18px; padding: 28px; transition: transform .2s ease; }
  .dv2-svc-card:hover { border-color: rgba(199,249,75,0.25); }
  .dv2-svc-icon { width: 46px; height: 46px; border-radius: 12px; background: rgba(199,249,75,0.1); display: flex; align-items: center; justify-content: center; margin-bottom: 18px; }
  .dv2-svc-card__title { font-family: 'Space Grotesk', sans-serif; font-weight: 600; font-size: 19px; margin-bottom: 9px; }
  .dv2-svc-card__desc { color: var(--muted); font-size: 15px; line-height: 1.55; }

  /* ── Process ── */
  .dv2-process-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(min(280px,100%),1fr)); gap: 20px; }
  .dv2-process-card { border: 1px solid var(--border); background: var(--card); border-radius: 18px; padding: 32px 28px; }
  .dv2-process-num { font-family: 'Space Grotesk', sans-serif; font-weight: 700; font-size: 54px; color: rgba(199,249,75,0.25); line-height: 1; margin-bottom: 18px; }
  .dv2-process-card__title { font-family: 'Space Grotesk', sans-serif; font-weight: 600; font-size: 21px; margin-bottom: 10px; }
  .dv2-process-card__desc { color: var(--muted); font-size: 15px; line-height: 1.6; }

  /* ── Stats ── */
  .dv2-stats-strip { border-top: 1px solid var(--border); border-bottom: 1px solid var(--border); padding: clamp(56px,7vw,90px) 0; }
  .dv2-stats-strip__row { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px,1fr)); gap: 32px; text-align: center; }
  .dv2-stat__val { font-family: 'Space Grotesk', sans-serif; font-weight: 700; font-size: clamp(34px,4.5vw,48px); color: var(--acc); }
  .dv2-stat__label { color: var(--muted); font-size: 15px; margin-top: 6px; }

  /* ── Testimonials ── */
  .dv2-testi-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px,1fr)); gap: 20px; }
  .dv2-testi-card { border: 1px solid var(--border); background: var(--card); border-radius: 18px; padding: 30px; }
  .dv2-testi-card__quote { font-size: 17px; line-height: 1.6; color: #D7DCE3; margin-bottom: 22px; }
  .dv2-testi-card__author { display: flex; align-items: center; gap: 12px; }
  .dv2-testi-card__avatar { width: 42px; height: 42px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 14px; flex-shrink: 0; }

  /* ── Form ── */
  .dv2-form-glow { position: absolute; inset: 0; background: radial-gradient(60% 60% at 50% 30%, rgba(199,249,75,0.09), transparent 70%); pointer-events: none; }
  .dv2-form-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(min(320px,100%),1fr)); gap: 48px; align-items: center; position: relative; }
  .dv2-form-benefits { display: flex; flex-direction: column; gap: 14px; }
  .dv2-form-benefit { display: flex; align-items: flex-start; gap: 12px; }
  .dv2-form-benefit__check { flex: none; width: 24px; height: 24px; border-radius: 7px; background: rgba(199,249,75,0.18); color: var(--acc); display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 13px; }
  .dv2-form-card { border: 1px solid rgba(255,255,255,0.1); background: var(--card); border-radius: 22px; padding: 30px; box-shadow: 0 30px 80px rgba(0,0,0,0.5); }
  .dv2-form-field { margin-bottom: 16px; }
  .dv2-form-label { display: block; font-size: 13px; font-weight: 600; color: var(--muted); margin-bottom: 7px; }
  .dv2-form-opt { color: #5b6472; font-weight: 500; }
  .dv2-wa-dot { display: inline-block; width: 8px; height: 8px; border-radius: 50%; background: #25D366; margin-right: 6px; vertical-align: middle; position: relative; top: -1px; }
  .dv2-input { width: 100%; background: var(--input); border: 1px solid rgba(255,255,255,0.12); border-radius: 11px; padding: 13px 14px; color: var(--text); font-family: 'Manrope', sans-serif; font-size: 15px; outline: none; transition: border-color .2s; }
  .dv2-input:focus { border-color: var(--acc); }
  .dv2-input::placeholder { color: #5b6472; }
  .dv2-input--err { border-color: #ff6b6b; }
  .dv2-cs-wrap { position: relative; }
  .dv2-cs-trigger { display: flex; align-items: center; justify-content: space-between; cursor: pointer; user-select: none; gap: 8px; }
  .dv2-cs-trigger--open { border-color: var(--acc); }
  .dv2-cs-search { flex: 1; background: none; border: none; outline: none; color: var(--text); font-family: "Manrope", sans-serif; font-size: 15px; padding: 0; width: 100%; }
  .dv2-cs-search::placeholder { color: #5b6472; }
  .dv2-cs-value { flex: 1; font-size: 15px; color: var(--text); }
  .dv2-cs-placeholder { flex: 1; font-size: 15px; color: #5b6472; }
  .dv2-cs-chevron { flex-shrink: 0; transition: transform .2s; }
  .dv2-cs-chevron--open { transform: rotate(180deg); }
  .dv2-cs-dropdown { position: absolute; top: calc(100% + 6px); left: 0; right: 0; background: #0E1116; border: 1px solid rgba(255,255,255,0.12); border-radius: 11px; overflow-y: auto; max-height: 196px; z-index: 100; box-shadow: 0 16px 40px rgba(0,0,0,0.5); scrollbar-width: thin; scrollbar-color: rgba(255,255,255,0.12) transparent; }
  .dv2-cs-option { padding: 10px 14px; font-size: 14px; color: var(--text); cursor: pointer; transition: background .12s; }
  .dv2-cs-option:hover { background: rgba(255,255,255,0.06); }
  .dv2-cs-option--active { color: var(--acc); background: rgba(199,249,75,0.08); }
  .dv2-cs-empty { padding: 14px; font-size: 14px; color: var(--muted); text-align: center; }
  .dv2-field-err { color: #ff6b6b; font-size: 12px; margin-top: 6px; }
  .dv2-form-note { text-align: center; color: #7F8794; font-size: 13px; margin-top: 14px; line-height: 1.5; }
  .dv2-form-success { text-align: center; padding: 30px 6px; animation: dv2-pop .4s ease; }
  .dv2-form-success__icon { width: 64px; height: 64px; border-radius: 50%; background: rgba(199,249,75,0.18); display: flex; align-items: center; justify-content: center; margin: 0 auto 22px; color: var(--acc); font-size: 30px; font-weight: 800; }
  .dv2-form-success__title { font-family: 'Space Grotesk', sans-serif; font-weight: 700; font-size: 24px; margin-bottom: 12px; }
  @keyframes dv2-pop { from { transform: scale(.85); opacity: 0; } to { transform: scale(1); opacity: 1; } }

  /* ── FAQ ── */
  .dv2-faq-list { display: flex; flex-direction: column; gap: 12px; }
  .dv2-faq-item { border: 1px solid var(--border); background: var(--card); border-radius: 14px; overflow: hidden; }
  .dv2-faq-q { width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 16px; background: transparent; border: none; color: var(--text); font-family: 'Manrope', sans-serif; font-weight: 600; font-size: 17px; text-align: left; padding: 20px 22px; cursor: pointer; }
  .dv2-faq-sign { font-size: 24px; font-weight: 400; line-height: 1; flex-shrink: 0; }
  .dv2-faq-a { padding: 0 22px 22px; color: var(--muted); font-size: 15px; line-height: 1.65; }

  /* ── CTA Banner ── */
  .dv2-cta-banner { border-radius: 26px; border: 1px solid rgba(199,249,75,0.3); background: linear-gradient(135deg, rgba(199,249,75,0.12), var(--card)); padding: clamp(36px,5vw,60px); text-align: center; position: relative; overflow: hidden; }
  .dv2-cta-banner__glow { position: absolute; inset: 0; background: radial-gradient(50% 80% at 50% 0%, rgba(199,249,75,0.14), transparent 70%); pointer-events: none; }
  .dv2-cta-banner__title { position: relative; font-family: 'Space Grotesk', sans-serif; font-weight: 700; font-size: clamp(28px,4.4vw,46px); line-height: 1.06; letter-spacing: -0.02em; margin-bottom: 16px; }
  .dv2-cta-banner__sub { position: relative; color: #B7BEC9; font-size: 17px; line-height: 1.55; max-width: 560px; margin: 0 auto 30px; }
  .dv2-cta-banner .dv2-btn { position: relative; font-size: 17px; padding: 18px 32px; border-radius: 14px; }

  /* ── Footer ── */
  .dv2-footer { border-top: 1px solid var(--border); padding: 44px 0; }
  .dv2-footer__inner { display: flex; flex-wrap: wrap; gap: 24px; align-items: center; justify-content: space-between; }
  .dv2-footer__brand { display: flex; align-items: center; }
  .dv2-footer__copy { color: #6a727f; font-size: 14px; }

  /* ── FAB ── */
  .dv2-fab { position: fixed; bottom: 22px; right: 22px; z-index: 70; display: flex; align-items: center; gap: 9px; background: var(--acc); color: var(--ink); font-family: 'Manrope', sans-serif; font-weight: 700; font-size: 15px; padding: 14px 22px; border-radius: 999px; border: none; cursor: pointer; box-shadow: 0 12px 40px rgba(199,249,75,0.4); transition: opacity .3s ease, transform .3s ease; }

  /* ── Social proof / Urgency / WA / Privacy / Modal ── */
  .dv2-social-proof { display: flex; align-items: center; gap: 8px; font-size: 13px; color: rgba(199,249,75,0.85); margin-bottom: 14px; }
  .dv2-social-proof__dot { width: 7px; height: 7px; border-radius: 50%; background: #C7F94B; flex-shrink: 0; animation: dv2-pulse 2s ease-in-out infinite; }
  @keyframes dv2-pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.45; } }
  .dv2-urgency { display: flex; align-items: flex-start; gap: 10px; margin-top: 24px; padding: 13px 16px; background: rgba(199,249,75,0.05); border: 1px solid rgba(199,249,75,0.2); border-radius: 11px; font-size: 13.5px; color: rgba(237,239,242,0.72); line-height: 1.45; }
  .dv2-wa-alt { text-align: center; margin-top: 12px; font-size: 13px; color: var(--muted); }
  .dv2-wa-alt__link { font-weight: 700; color: #25D366; text-decoration: none; transition: opacity 0.15s; }
  .dv2-wa-alt__link:hover { opacity: 0.82; }
  .dv2-privacy-link { background: none; border: none; color: var(--muted); font-size: inherit; font-family: inherit; cursor: pointer; text-decoration: underline; padding: 0; }
  .dv2-privacy-link:hover { color: var(--text); }
  .dv2-modal-overlay { position: fixed; inset: 0; z-index: 200; background: rgba(0,0,0,0.78); backdrop-filter: blur(4px); display: flex; align-items: center; justify-content: center; padding: 20px; }
  .dv2-pm { background: var(--card); border: 1px solid rgba(255,255,255,0.1); border-radius: 18px; width: 100%; max-width: 540px; max-height: 80vh; overflow-y: auto; scrollbar-width: thin; scrollbar-color: rgba(255,255,255,0.1) transparent; }
  .dv2-pm__header { display: flex; align-items: center; justify-content: space-between; padding: 20px 24px 16px; border-bottom: 1px solid rgba(255,255,255,0.08); }
  .dv2-pm__title { font-family: 'Space Grotesk', sans-serif; font-weight: 700; font-size: 18px; }
  .dv2-pm__close { background: none; border: none; color: var(--muted); font-size: 16px; cursor: pointer; padding: 4px 8px; border-radius: 6px; transition: color 0.15s; }
  .dv2-pm__close:hover { color: var(--text); }
  .dv2-pm__body { padding: 20px 24px 26px; display: flex; flex-direction: column; gap: 10px; font-size: 14px; line-height: 1.72; color: rgba(237,239,242,0.72); }
  .dv2-pm__updated { font-size: 12px; color: var(--muted); }
  .dv2-pm__body h4 { font-size: 13.5px; font-weight: 700; color: var(--text); margin-top: 4px; }
  .dv2-pm__body a { color: var(--acc); text-decoration: underline; text-underline-offset: 3px; }
  /* ── Responsive ── */
  @media (max-width: 960px) {
    .dv2-nav__links { position: absolute; top: 64px; left: 0; right: 0; flex-direction: column; gap: 0; background: rgba(10,11,13,0.96); backdrop-filter: blur(20px); padding: 8px 24px 20px; border-bottom: 1px solid var(--border); opacity: 0; visibility: hidden; transform: translateY(-10px); transition: opacity .25s, transform .3s, visibility .3s; }
    .dv2-nav__links.is-open { opacity: 1; visibility: visible; transform: translateY(0); }
    .dv2-nav__links a { padding: 14px 0; border-bottom: 1px solid var(--border); display: block; }
    .dv2-burger { display: flex; }
    .dv2-nav__cta { display: none; }
  }
  @media (max-width: 640px) {
    .dv2-wrap, .dv2-wrap--narrow { padding: 0 16px; }
    .dv2-section__head { margin-bottom: 36px; }
    .dv2-hero { padding-top: 88px; padding-bottom: 48px; }
    .dv2-hero__left, .dv2-hero__right { min-width: 0; width: 100%; }
    .dv2-hero__right { height: clamp(240px, 56vw, 340px); }
    .dv2-hero__cta .dv2-btn { flex: 1 1 100%; }
    .dv2-float--top { display: none; }
    .dv2-form-card { padding: 22px 18px; }
    .dv2-footer__inner { flex-direction: column; text-align: center; }
    .dv2-faq-q { font-size: 15px; padding: 17px 18px; }
    .dv2-faq-a { padding: 0 18px 18px; }
    .dv2-cta-banner .dv2-btn { width: 100%; font-size: 15px; padding: 16px 24px; }
    .dv2-fab { padding: 12px 18px; font-size: 14px; }
  }
`;
